export default {
  setShipmentOrderStatus(state, payload) {
    state.shipmentOrderStatus = payload;
  },
  toggleLoading(state, isLoading) {
    state.loading = isLoading;
  },
};



// WEBPACK FOOTER //
// ./src/features/private/dashboard/dashboards/sc-dashboard-order-status/store/mutations.js